module.exports = "files/coin.mp3";